import React from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import DescriptionIcon from '@mui/icons-material/Description';
import PeopleIcon from '@mui/icons-material/People';
import InsightsIcon from '@mui/icons-material/Insights';
import { colors } from '../../styles/css/colors';
import { DART_USER_GUIDE, ROUTES } from '../../config/constant';
import { useAuth } from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';

const Hamburger: React.FC = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { canManageUsers } = useAuth();
  const navigate = useNavigate();

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleUserGuide = () => {
    window.open(DART_USER_GUIDE, '_blank');
    handleClose();
  };

  const handleUserAccess = () => {
    navigate(ROUTES.USER_ACCESS);
    handleClose();
  };

  const handleUserActivity = () => {
    navigate(ROUTES.USER_ACTIVITY);
    handleClose();
  };

  return (
    <>
      <IconButton
        size="large"
        edge="end"
        aria-label="menu"
        aria-controls="hamburger-menu"
        aria-haspopup="true"
        onClick={handleMenu}
        color="inherit"
      >
        <MenuIcon sx={{ color: colors.PRIMARY }} />
      </IconButton>
      <Menu
        id="hamburger-menu"
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        keepMounted
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={open}
        onClose={handleClose}
        sx={{
          '& .MuiPaper-root': {
            maxHeight: 260,
          },
          '& .MuiList-root': {
            paddingTop: '4px',
            paddingBottom: '4px',
          },
        }}
      >
        <MenuItem onClick={handleUserGuide} sx={{ fontSize: '0.875rem', padding: '4px 12px', minHeight: 'auto' }}>
          <DescriptionIcon fontSize="small" style={{ marginRight: 8 }} /> User Guide
        </MenuItem>
        {canManageUsers && (
          <MenuItem onClick={handleUserAccess} sx={{ fontSize: '0.875rem', padding: '4px 12px', minHeight: 'auto' }}>
            <PeopleIcon fontSize="small" style={{ marginRight: 8 }} /> User Access
          </MenuItem>
        )}
        {canManageUsers && (
          <MenuItem onClick={handleUserActivity} sx={{ fontSize: '0.875rem', padding: '4px 12px', minHeight: 'auto' }}>
            <InsightsIcon fontSize="small" style={{ marginRight: 8 }} /> User Activity
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

export default Hamburger;
